import { getActualProductId, getProductImages, getProductImageSrc, getProductName, getProductProperties } from "../cores/productCore";
import _ from "lodash";
import { productHasInventory } from "../cores/exchangeToProductsCore";
import { RETURN_REASON_TYPES } from "rylak-common/src/constants";

export function getMockedComplaintReasons() {
    return [
        {
            id: 2,
            type: "SIMPLE",
            isImageRequired: true,
            isTextRequired: true,
            translations: {
                NO: "Produktet er defekt",
                EN: "Item Faulty",
                SV: "Produkten är felaktig",
            },
        },
        {
            id: 1,
            type: "SIMPLE",
            isImageRequired: false,
            isTextRequired: false,
            translations: {
                NO: "Produktet har ikke kommet",
                EN: "Item Not Arrived",
                SV: "Produkten har inte kommit",
            },
        },
        {
            id: 3,
            type: "SIMPLE",
            isImageRequired: true,
            isTextRequired: false,
            translations: {
                NO: "Feil vare",
                EN: "Wrong Item",
                SV: "Fel produkt",
            },
        },
    ];
}

function regretPurchase({ id }) {
    return {
        id: id,
        type: RETURN_REASON_TYPES.SIMPLE,
        translations: {
            EN: "Regret purchase",
            SV: "Ångrat köp",
            NO: "Angrer på kjøp",
        },
    };
}

function badQuality({ id }) {
    return {
        id: id,
        type: RETURN_REASON_TYPES.SIMPLE,
        translations: {
            EN: "Quality not as expected",
            SV: "Dålig kvalitet",
            NO: "Dårlig kvalitet",
        },
    };
}

function tooExpensive({ id }) {
    return {
        id: id,
        type: RETURN_REASON_TYPES.SIMPLE,
        translations: {
            EN: "Too expensive",
            SV: "För dyr",
            NO: "For dyrt",
        },
    };
}

function freeShipping({ id }) {
    return {
        id: id,
        type: RETURN_REASON_TYPES.SIMPLE,
        translations: {
            EN: "Added it for free shipping",
            SV: "Köpt på grund av gratis fraktkostnad",
            NO: "Lagt den til for gratis frakt",
        },
    };
}

function notMyTea({ id }) {
    return {
        id: id,
        type: RETURN_REASON_TYPES.SIMPLE,
        translations: {
            EN: "Not my cup of tea",
            SV: "Motsvarade inte mina förväntningarna",
            NO: "Varen falt ikke i smak",
        },
    };
}

function wrongColor({ id }) {
    return {
        id: id,
        type: RETURN_REASON_TYPES.MULTIPLE_CHOICE,
        translations: {
            EN: "Color not as expected",
            SV: "Färg var inte som förväntat",
            NO: "Farge var ikke forventet",
        },
        subReasons: [
            {
                id: 1,
                translations: {
                    EN: "Too light",
                    SV: "För ljus",
                    NO: "For lyst",
                },
            },
            {
                id: 2,
                translations: {
                    EN: "Too dark",
                    SV: "För mörk",
                    NO: "For mørkt",
                },
            },
            {
                id: 3,
                translations: {
                    EN: "Wrong color",
                    SV: "Fel färg",
                    NO: "Feil farge",
                },
            },
        ],
    };
}

function other({ id }) {
    return {
        id: id,
        type: RETURN_REASON_TYPES.FREE_TEXT,
        translations: {
            EN: "Other",
            SV: "Annan orsak",
            NO: "Annen",
        },
    };
}

function wrongSize({ id, subReasons }) {
    return {
        id: id,
        type: RETURN_REASON_TYPES.MULTIPLE_CHOICE,
        translations: {
            EN: "Fit not as expected",
            SV: "Passar inte som förväntat",
            NO: "Passer ikke som forventet",
        },
        subReasons: subReasons,
    };
}

export function createReturnReasonConfigTop() {
    return {
        default: false,
        id: 999,
        name: "Return config top",
        returnReasons: [
            wrongSize({
                id: 1,
                subReasons: [
                    {
                        id: 1,
                        translations: {
                            EN: "Small overall",
                            SV: "För liten",
                            NO: "For liten",
                        },
                    },
                    {
                        id: 2,
                        translations: {
                            EN: "Large overall",
                            SV: "För stor",
                            NO: "For stor",
                        },
                    },
                    {
                        id: 3,
                        translations: {
                            EN: "Small bust",
                            SV: "Liten över bysten",
                            NO: "Liten byste",
                        },
                    },
                    {
                        id: 4,
                        translations: {
                            EN: "Large bust",
                            SV: "Stor över bysten",
                            NO: "Stor byste",
                        },
                    },
                    {
                        id: 5,
                        translations: {
                            EN: "Narrow shoulders",
                            SV: "Tajta axlar",
                            NO: "Smale skuldre",
                        },
                    },
                    {
                        id: 6,
                        translations: {
                            EN: "Wide shoulders",
                            SV: "Breda axlar",
                            NO: "Brede skuldre",
                        },
                    },
                    {
                        id: 7,
                        translations: {
                            EN: "Tight sleeves",
                            SV: "Smala ärmar",
                            NO: "Trange ermer",
                        },
                    },
                    {
                        id: 8,
                        translations: {
                            EN: "Wide sleeves",
                            SV: "Breda ärmar",
                            NO: "Vide ermer",
                        },
                    },
                    {
                        id: 9,
                        translations: {
                            EN: "Short model",
                            SV: "Kort i modellen",
                            NO: "Kort modell",
                        },
                    },
                    {
                        id: 10,
                        translations: {
                            EN: "Long model",
                            SV: "Lång i modellen",
                            NO: "Lang modell",
                        },
                    },
                ],
            }),
            regretPurchase({ id: 2 }),
            badQuality({ id: 3 }),
            tooExpensive({ id: 4 }),
            freeShipping({ id: 5 }),
            notMyTea({ id: 6 }),
            wrongColor({ id: 7 }),
            other({ id: 8 }),
        ],
        complaintReasons: getMockedComplaintReasons(),
    };
}

export function createReturnReasonConfigBottom() {
    return {
        default: false,
        id: 999,
        name: "Return config bottom",
        returnReasons: [
            wrongSize({
                id: 1,
                subReasons: [
                    {
                        id: 1,
                        translations: {
                            EN: "Small overall",
                            SV: "För liten",
                            NO: "For liten",
                        },
                    },
                    {
                        id: 2,
                        translations: {
                            EN: "Large overall",
                            SV: "För stor",
                            NO: "For stor",
                        },
                    },
                    {
                        id: 3,
                        translations: {
                            EN: "Long inseam",
                            SV: "Lång insöm",
                            NO: "Lang innersøm",
                        },
                    },
                    {
                        id: 4,
                        translations: {
                            EN: "Short inseam",
                            SV: "Kort insöm",
                            NO: "Kort innersøm",
                        },
                    },
                    {
                        id: 5,
                        translations: {
                            EN: "Tight hips",
                            SV: "Tajt över höfterna",
                            NO: "Stramme hofter",
                        },
                    },
                    {
                        id: 6,
                        translations: {
                            EN: "Wide hips",
                            SV: "Bred över höfterna",
                            NO: "Brede hofter",
                        },
                    },
                    {
                        id: 7,
                        translations: {
                            EN: "Tight waist",
                            SV: "Tajt över midjan",
                            NO: "Stram midje",
                        },
                    },
                    {
                        id: 8,
                        translations: {
                            EN: "Wide waist",
                            SV: "Bred över midjan",
                            NO: "Bred midje",
                        },
                    },
                    {
                        id: 9,
                        translations: {
                            EN: "High waist",
                            SV: "För hög midja",
                            NO: "Høy midje",
                        },
                    },
                    {
                        id: 10,
                        translations: {
                            EN: "Low waist",
                            SV: "För låg midja",
                            NO: "Lav midje",
                        },
                    },
                    {
                        id: 11,
                        translations: {
                            EN: "Tight thighs",
                            SV: "Tajt över låren",
                            NO: "Stramme lår",
                        },
                    },
                    {
                        id: 12,
                        translations: {
                            EN: "Wide thighs",
                            SV: "Bred över låren",
                            NO: "Brede lår",
                        },
                    },
                ],
            }),
            regretPurchase({ id: 2 }),
            badQuality({ id: 3 }),
            tooExpensive({ id: 4 }),
            freeShipping({ id: 5 }),
            notMyTea({ id: 6 }),
            wrongColor({ id: 7 }),
            other({ id: 8 }),
        ],
        complaintReasons: getMockedComplaintReasons(),
    };
}

export function createReturnReasonConfigStuff() {
    return {
        default: false,
        id: 999,
        name: "Return config stuff",
        returnReasons: [regretPurchase({ id: 2 }), badQuality({ id: 3 }), tooExpensive({ id: 4 }), freeShipping({ id: 5 }), notMyTea({ id: 6 }), wrongColor({ id: 7 }), other({ id: 8 })],
        complaintReasons: getMockedComplaintReasons(),
    };
}

export function createReturnReasonConfigAlga() {
    return {
        default: false,
        id: 999,
        name: "Return config stuff",
        returnReasons: [regretPurchase({ id: 2 }), badQuality({ id: 3 }), tooExpensive({ id: 4 }), freeShipping({ id: 5 }), notMyTea({ id: 6 }), other({ id: 8 })],
        complaintReasons: getMockedComplaintReasons(),
    };
}

export function createReturnReasonConfigShoes() {
    return {
        default: false,
        id: 999,
        name: "Return config shoes",
        returnReasons: [
            wrongSize({
                id: 1,
                subReasons: [
                    {
                        id: 1,
                        translations: {
                            EN: "Small overall",
                            SV: "För liten",
                            NO: "For liten",
                        },
                    },
                    {
                        id: 2,
                        translations: {
                            EN: "Large overall",
                            SV: "För stor",
                            NO: "For stor",
                        },
                    },
                ],
            }),
            regretPurchase({ id: 2 }),
            badQuality({ id: 3 }),
            tooExpensive({ id: 4 }),
            freeShipping({ id: 5 }),
            notMyTea({ id: 6 }),
            wrongColor({ id: 7 }),
            other({ id: 8 }),
        ],
        complaintReasons: getMockedComplaintReasons(),
    };
}

export function createProperties() {
    return [
        {
            type: "Size",
            value: "S",
        },
        {
            type: "Color",
            value: "Green",
        },
    ];
}

function propertiesToVariantTitle(properties) {
    return properties.map((p) => p.value).join(" / ");
}

export function productToVariantFullTitle(product, properties) {
    return getProductName(product) + " " + propertiesToVariantTitle(properties || getProductProperties(product));
}

//     {
//     id: product.productVariantId,
//     title: propertiesToVariantTitle(getProductProperties(product)),
//     fullTitle: productToVariantFullTitle(product),
//     imageSrc: getProductImageSrc(product),
//     properties: getProductProperties(product),
//     inventoryTurnr,
//     inventoryMerchant,
//     inventoryTotal,
//     hasInventory: inventoryTotal > 0,
//     isOriginal: true,
// }

export function createProductVariant({ product, variant, index }) {
    const inventoryTurnr = _.isNil(variant?.inventoryTurnr) ? 1 : variant?.inventoryTurnr;
    const inventoryMerchant = _.isNil(variant?.inventoryMerchant) ? 1 : variant?.inventoryMerchant;
    const inventoryTotal = inventoryTurnr + inventoryMerchant;
    const properties = variant?.properties || [];
    return {
        id: variant?.id || product.productVariantId + "_" + index,
        title: propertiesToVariantTitle(properties),
        fullTitle: productToVariantFullTitle(product, properties),
        imageSrc: getProductImageSrc(variant) || getProductImageSrc(product),
        imageSrcs: getProductImages(variant) || getProductImages(product),
        properties,
        inventoryTurnr,
        inventoryMerchant,
        inventoryTotal,
        hasInventory: inventoryTotal > 0,
        isOriginal: variant?.isOriginal || false,
    };
}

export function createExchangeToProduct({ product, variants }) {
    const actualVariants =
        variants?.map((variant, index) => {
            const inventoryTurnr = _.isNil(variant?.inventoryTurnr) ? 1 : variant?.inventoryTurnr;
            const inventoryMerchant = _.isNil(variant?.inventoryMerchant) ? 1 : variant?.inventoryMerchant;
            const inventoryTotal = inventoryTurnr + inventoryMerchant;
            const properties = variant?.properties || [];
            return {
                id: variant?.id || product.productVariantId + "_" + index,
                title: propertiesToVariantTitle(properties),
                fullTitle: productToVariantFullTitle(product, properties),
                imageSrc: getProductImageSrc(variant) || getProductImageSrc(product),
                imageSrcs: getProductImages(variant) || getProductImages(product),
                properties,
                inventoryTurnr,
                inventoryMerchant,
                inventoryTotal,
                hasInventory: inventoryTotal > 0,
                isOriginal: false,
            };
        }) || [];
    return {
        id: getActualProductId(product),
        productName: getProductName(product),
        imageSrc: getProductImageSrc(product),
        imageSrcs: getProductImages(product),
        isOriginal: true,
        hasInventory: !!actualVariants.find((v) => v.hasInventory),
        variants: actualVariants,
    };
}

export function createExchangeToProducts({ product, exchangeToProductsData }) {
    const originalExchangeToProduct = createExchangeToProduct({
        product,
        variants: exchangeToProductsData?.originalProductVariants,
    });
    const otherExchangeToProducts = exchangeToProductsData?.otherProducts || [];
    return [originalExchangeToProduct].concat(otherExchangeToProducts);
}

export function createProductsAndExchangeToProductsFn(productAndExchangeToProductDataList) {
    let products = [];
    let exchangeToProducts = [];
    let similarProductsList = {};
    productAndExchangeToProductDataList.forEach(({ product, exchangeToProductsData, similarProducts, index }) => {
        products.push(product);
        const originalVariant = createProductVariant({
            product,
            variant: {
                id: product?.productVariantId,
                properties: getProductProperties(product),
                isOriginal: true,
                index: index,
            },
        });
        const exchangeProducts = createExchangeToProducts({
            product,
            exchangeToProductsData,
        });
        exchangeToProducts[product.sessionItemId] = {
            originalVariant,
            exchangeAlternativeExists: !!exchangeProducts?.find((p) => productHasInventory(p)),
            complaintOptions: exchangeProducts,
            products: exchangeProducts,
        };
        if (similarProducts) {
            similarProductsList[product?.actualProductId] = {
                similarProducts,
            };
        }
    });

    return {
        products: products,
        exchangeToProductsFn: ({ productId }) => exchangeToProducts[productId],
        similarProductsFn: ({ productId }) => similarProductsList[productId],
    };
}

export function createMockProduct({
    id,
    sessionItemId = "session_" + id,
    variantId = "variant_" + id,
    productName = "Some product name",
    returnId,
    imageSrc,
    quantity = 1,
    purchasePrice = 499,
    returnReasonConfig = createReturnReasonConfigTop(),
    complaintReasons = getMockedComplaintReasons(),
    properties = createProperties(),
    ...rest
} = {}) {
    return {
        productVariantId: variantId,
        sessionItemId: sessionItemId,
        actualProductId: id,
        productName: productName,
        imageSrc: imageSrc,
        imageAlt: imageSrc,
        quantity: quantity,
        returnable: !returnId,
        purchasePrice: purchasePrice,
        properties: properties,
        returnReasonConfig: returnReasonConfig,
        ...rest,
    };
}
